<template>
  <span>
    <a :href="showLink" target="_blank" v-on:click.stop v-if="canShow">
      {{ name }}
    </a>
    <span v-else>
      {{ name }}
    </span>
  </span>
</template>
<script>
export default {
  name: "AttachableShowLinkComponent",
  props: {
    attachable: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    childInstance() {
      return this.attachable.child_instance.data;
    },
    name() {
      return this.childInstance.name;
    },
    size() {
      return this.childInstance.size;
    },
    canShow() {
      return typeof this.childInstance.show_link !== "undefined";
    },
    showLink() {
      return this.childInstance.show_link;
    }
  },
}
</script>